<!-- Template List -->
@if (!selectedTemplate()) {
  <div class="space-y-4">
    <div class="flex items-center justify-between">
      <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-200">
        📋 Choisir un template de catalogue
      </h3>
      <button
        (click)="close.emit()"
        class="text-gray-400 hover:text-gray-600 text-xl"
      >
        ✕
      </button>
    </div>

    @if (loading()) {
      <div class="flex justify-center py-8">
        <div
          class="animate-spin h-8 w-8 border-4 border-primary-500 border-t-transparent rounded-full"
        ></div>
      </div>
    }

    @if (error()) {
      <div
        class="p-3 bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 rounded-lg text-sm"
      >
        {{ error() }}
      </div>
    }

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      @for (t of templates(); track t._id) {
        <button
          (click)="selectTemplate(t)"
          class="p-4 border border-gray-200 dark:border-gray-700 rounded-xl text-left hover:border-primary-400 hover:shadow-md transition-all bg-white dark:bg-gray-800"
        >
          <div class="flex items-center gap-2 mb-2">
            <span class="text-2xl">{{ t.icon }}</span>
            <span class="font-medium text-gray-900 dark:text-gray-100">{{
              t.name
            }}</span>
          </div>
          <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">
            {{ t.description }}
          </p>
          <div class="flex items-center gap-2 text-xs text-gray-400">
            <span>{{ t.productCount }} produits</span>
            <span>•</span>
            <span>{{ t.topProducts.slice(0, 3).join(", ") }}</span>
          </div>
        </button>
      }
    </div>

    @if (!loading() && templates().length === 0 && !error()) {
      <p class="text-center text-gray-500 py-4">
        Aucun template disponible pour votre activité.
      </p>
    }
  </div>
}

<!-- Template Detail -->
@if (selectedTemplate(); as tmpl) {
  <div class="space-y-4">
    <button
      (click)="backToList()"
      class="text-sm text-primary-600 hover:underline flex items-center gap-1"
    >
      ← Retour aux templates
    </button>

    <div class="flex items-center gap-3">
      <span class="text-3xl">{{ tmpl.icon }}</span>
      <div>
        <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-200">
          {{ tmpl.name }}
        </h3>
        <p class="text-sm text-gray-500">{{ tmpl.description }}</p>
      </div>
    </div>

    <!-- Products preview -->
    <div class="border dark:border-gray-700 rounded-lg overflow-hidden">
      <table class="w-full text-sm">
        <thead class="bg-gray-50 dark:bg-gray-800">
          <tr>
            <th class="px-3 py-2 text-left">Produit</th>
            <th class="px-3 py-2 text-left">Catégorie</th>
            <th class="px-3 py-2 text-right">Prix</th>
            <th class="px-3 py-2 text-right">Qté</th>
          </tr>
        </thead>
        <tbody>
          @for (p of tmpl.products; track p.name) {
            <tr class="border-t dark:border-gray-700">
              <td class="px-3 py-2">{{ p.productIcon }} {{ p.name }}</td>
              <td class="px-3 py-2 text-gray-500">{{ p.category }}</td>
              <td class="px-3 py-2 text-right">
                {{ p.defaultPrice | number: "1.2-2" }} €
              </td>
              <td class="px-3 py-2 text-right">{{ p.defaultQuantity }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Apply controls -->
    @if (!isOnboarding()) {
      <div
        class="flex items-center gap-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg"
      >
        <label class="flex items-center gap-2 text-sm cursor-pointer">
          <input
            type="radio"
            name="mode"
            value="merge"
            [checked]="applyMode() === 'merge'"
            (change)="applyMode.set('merge')"
          />
          <span>Fusionner (garder mes produits existants)</span>
        </label>
        <label class="flex items-center gap-2 text-sm cursor-pointer">
          <input
            type="radio"
            name="mode"
            value="replace"
            [checked]="applyMode() === 'replace'"
            (change)="applyMode.set('replace')"
          />
          <span>Remplacer (archiver les existants)</span>
        </label>
      </div>
    }

    <button
      (click)="apply()"
      [disabled]="applying()"
      class="w-full py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 disabled:opacity-50 transition-colors shadow-md"
    >
      @if (applying()) {
        Application en cours...
      } @else if (isOnboarding()) {
        ➕ Ajouter ces produits ({{ tmpl.products.length }})
      } @else {
        Appliquer ce template ({{ tmpl.products.length }} produits)
      }
    </button>
  </div>
}
